import React, { useState } from 'react';
import axios from 'axios';

const LoginScreen = ({ onLoginSuccess, apiBaseUrl = 'http://localhost:5000', prefillEmail = '' }) => {
  const [mode, setMode] = useState('login'); // 'login' or 'register'
  const [apiKey, setApiKey] = useState('');
  const [loginError, setLoginError] = useState('');
  
  // Email/Password форма
  const [email, setEmail] = useState(prefillEmail);
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [emailPasswordUser, setEmailPasswordUser] = useState(null);
  const [registrationSuccess, setRegistrationSuccess] = useState('');
  const [consentGiven, setConsentGiven] = useState(false);

  // Обновляем email при изменении prefillEmail
  React.useEffect(() => {
    if (prefillEmail) {
      setEmail(prefillEmail);
    }
  }, [prefillEmail]);

  const handleEmailPasswordSubmit = async (e) => {
    e.preventDefault();
    setLoginError('');
    
    const endpoint = mode === 'register' ? '/api/auth/register' : '/api/auth/login';
    const payload = mode === 'register' 
      ? { email, password, name }
      : { email, password };
    
    try {
      const response = await axios.post(`${apiBaseUrl}${endpoint}`, payload);
      
      if (response.data.success) {
        if (mode === 'register') {
          // Цель Яндекс.Метрики: успешная регистрация
          if (window.ym) window.ym(111057568, 'reachGoal', 'REGISTRATION');
          if (response.data.confirm_url) {
            // Email не отправлен, показываем ссылку напрямую
            setRegistrationSuccess(
              <div>
                <p>{response.data.message}</p>
                <p style={{marginTop: '10px', wordBreak: 'break-all'}}>
                  <strong>Ссылка для подтверждения:</strong><br/>
                  <a href={response.data.confirm_url} target="_blank" rel="noopener noreferrer">
                    {response.data.confirm_url}
                  </a>
                </p>
                <p style={{marginTop: '10px', fontSize: '12px', color: 'var(--muted)'}}>
                  {response.data.note}
                </p>
              </div>
            );
          } else {
            setRegistrationSuccess(response.data.message || 'Регистрация успешна! Пожалуйста, подтвердите email.');
          }
          setMode('login');
          setEmail('');
          setPassword('');
          setName('');
        } else {
          setEmailPasswordUser({
            token: response.data.token,
            user: response.data.user,
            subscription: response.data.subscription
          });
          setLoginError('');
        }
      }
    } catch (err) {
      if (err.response?.status === 403 && err.response?.data?.not_confirmed) {
        setLoginError(err.response.data.error);
      } else {
        setLoginError(err.response?.data?.error || `Ошибка ${mode === 'register' ? 'регистрации' : 'входа'}`);
      }
      console.error(err);
    }
  };

  const handleVerifyApiKey = async () => {
    try {
      const user = emailPasswordUser;
      const response = await axios.post(`${apiBaseUrl}/api/auth/verify-api-key`, {
        api_key: apiKey
      }, {
        headers: {
          'Authorization': `Bearer ${user.token}`
        }
      });
      
      if (response.data.success) {
        onLoginSuccess(user.token, user.user, apiKey, user.subscription);
      } else {
        setLoginError('Неверный код доступа');
      }
    } catch (err) {
      setLoginError(err.response?.data?.error || 'Ошибка проверки кода доступа');
    }
  };

  const currentUser = emailPasswordUser;

  return (
    <div className="login-container" style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '60vh',
      maxWidth: '450px',
      margin: '0 auto',
      padding: '40px',
      backgroundColor: 'var(--panel)',
      borderRadius: '12px',
      boxShadow: '0 10px 25px rgba(0,0,0,0.1)'
    }}>
      <h2 style={{ marginBottom: '10px' }}>
        {mode === 'register' ? 'Регистрация' : 'Вход в систему'}
      </h2>
      <p style={{ color: 'var(--muted)', textAlign: 'center', marginBottom: '30px' }}>
        Для использования анализатора необходимо авторизоваться и ввести код доступа
      </p>

      {registrationSuccess && (
        <div style={{
          backgroundColor: '#d4edda',
          color: '#155724',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '20px',
          fontSize: '14px',
          textAlign: 'center',
          width: '100%',
          boxSizing: 'border-box',
          border: '1px solid #c3e6cb'
        }}>
          {registrationSuccess}
        </div>
      )}

      {!currentUser ? (
        <>
          {/* Email/Password форма */}
          <form onSubmit={handleEmailPasswordSubmit} style={{ width: '100%', marginBottom: '20px' }}>
            {mode === 'register' && (
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px', fontSize: '14px' }}>
                  Имя:
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Ваше имя"
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border)',
                    boxSizing: 'border-box'
                  }}
                />
              </div>
            )}
            
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px', fontSize: '14px' }}>
                Email:
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="your@email.com"
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid var(--border)',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px', fontSize: '14px' }}>
                Пароль:
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '8px',
                  border: '1px solid var(--border)',
                  boxSizing: 'border-box'
                }}
              />
            </div>
            
            <button
              type="submit"
              disabled={mode === 'register' && !consentGiven}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: (mode === 'register' && !consentGiven) ? 'var(--border)' : '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: (mode === 'register' && !consentGiven) ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                marginBottom: '10px'
              }}
            >
              {mode === 'register' ? 'Зарегистрироваться' : 'Войти'}
            </button>
            
            {mode === 'register' && (
              <div style={{ 
                marginTop: '12px', 
                marginBottom: '4px', 
                textAlign: 'left', 
                fontSize: '13px', 
                color: 'var(--muted)',
                display: 'flex',
                alignItems: 'flex-start',
                gap: '8px'
              }}>
                <input
                  type="checkbox"
                  checked={consentGiven}
                  onChange={(e) => setConsentGiven(e.target.checked)}
                  style={{ marginTop: '3px', cursor: 'pointer' }}
                  id="consent-checkbox"
                />
                <label htmlFor="consent-checkbox" style={{ cursor: 'pointer', lineHeight: '1.4' }}>
                  Я даю согласие на обработку персональных данных в соответствии с{' '}
                  <a href="/privacy.html" target="_blank" rel="noopener noreferrer" style={{ color: '#64b5f6' }}>
                    Политикой конфиденциальности
                  </a>{' '}(152-ФЗ)
                </label>
              </div>
            )}
            
            <button
              type="button"
              onClick={() => { setMode(mode === 'login' ? 'register' : 'login'); setConsentGiven(false); }}
              style={{
                width: '100%',
                padding: '8px',
                backgroundColor: 'transparent',
                color: '#64b5f6',
                border: 'none',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              {mode === 'login' ? 'Нет аккаунта? Зарегистрируйтесь' : 'Уже есть аккаунт? Войдите'}
            </button>
          </form>
        </>
      ) : (
        <div style={{ width: '100%', textAlign: 'center' }}>
          <div style={{ marginBottom: '20px', padding: '10px', backgroundColor: 'var(--panel-2)', borderRadius: '8px' }}>
            {currentUser.user.picture && (
              <img 
                src={currentUser.user.picture} 
                alt="Avatar" 
                style={{ width: '50px', borderRadius: '50%', marginBottom: '10px' }} 
              />
            )}
            {!currentUser.user.picture && (
              <div style={{
                width: '50px',
                height: '50px',
                borderRadius: '50%',
                backgroundColor: '#007bff',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                margin: '0 auto 10px',
                fontWeight: 'bold'
              }}>
                {currentUser.user.name?.charAt(0).toUpperCase()}
              </div>
            )}
            <div style={{ fontWeight: 'bold' }}>{currentUser.user.name}</div>
            <div style={{ fontSize: '12px', color: 'var(--muted)' }}>{currentUser.user.email}</div>
          </div>
          
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', textAlign: 'left', marginBottom: '5px', fontSize: '14px' }}>
              Введите код доступа:
            </label>
            <input
              type="password"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter' && apiKey) { e.preventDefault(); handleVerifyApiKey(); }}}
              placeholder="Код доступа..."
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '8px',
                border: '1px solid var(--border)',
                marginBottom: '15px',
                boxSizing: 'border-box'
              }}
            />
            <button
              onClick={handleVerifyApiKey}
              disabled={!apiKey}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Подтвердить и войти
            </button>
          </div>
        </div>
      )}

      {loginError && (
        <div style={{ color: '#dc3545', marginTop: '15px', fontSize: '14px', textAlign: 'center' }}>
          {loginError}
        </div>
      )}
    </div>
  );
};

export default LoginScreen;
